import { render, staticRenderFns } from "./PrivacyContract.vue?vue&type=template&id=74c9fa91&scoped=true&"
import script from "./PrivacyContract.vue?vue&type=script&lang=js&"
export * from "./PrivacyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9fa91",
  null
  
)

export default component.exports